export const corvidBundlesConfig = {
    parts: false,
    components: true,
    host: true,
};
export const corvidConventions = {
    getComponentName: ({ componentName }) => {
        return componentName;
    },
    patterns: [
        {
            part: 'sdk',
            path: '{,*/}%ComponentName%/corvid/%ComponentName%.corvid.ts',
        },
    ],
};
//# sourceMappingURL=corvid.js.map